import type { ButtonBaseProps } from '~shared/ui/atoms';

import { StyledBase, StyledLabel } from './styles';

type Props = {
	label?: string;
	isLabelStrike?: boolean;
} & ButtonBaseProps;

export const ButtonPrimary = ({
	label,
	isLabelStrike,
	...restProps
}: Props) => (
	<StyledBase {...restProps}>
		{label && <StyledLabel isStrike={isLabelStrike}>{label}</StyledLabel>}
	</StyledBase>
);
